import React, { useMemo } from "react";
import "./our_student.css";

type VideoItem = {
  title: string;
  youtubeId?: string;
  drivePreviewUrl?: string;
};

type MentoredStudentCard = {
  name: string;
  subtitle?: string;
  driveImageId: string;
  driveTextImageId: string;
};

function getDriveImageUrl(fileId: string) {
  return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1600`;
}

function getDriveImageFallbacks(fileId: string) {
  return [
    `https://drive.google.com/thumbnail?id=${fileId}&sz=w1600`,
    `https://drive.google.com/uc?export=view&id=${fileId}`,
    `https://drive.google.com/uc?export=download&id=${fileId}`,
    `https://docs.google.com/uc?export=view&id=${fileId}`,
    `https://docs.google.com/uc?export=download&id=${fileId}`,
    `https://drive.usercontent.google.com/u/0/uc?id=${fileId}&export=view`,
    `https://drive.usercontent.google.com/u/0/uc?id=${fileId}&export=download`,
    `https://lh3.googleusercontent.com/d/${fileId}=w1600`,
    `https://drive.usercontent.google.com/download?id=${fileId}&export=view&authuser=0`,
  ];
}

function handleDriveImageError(event: React.SyntheticEvent<HTMLImageElement>) {
  const img = event.currentTarget;
  const rawFallbacks = img.dataset.fallbacks;
  if (!rawFallbacks) return;

  const fallbacks = rawFallbacks.split("|").filter(Boolean);
  const currentIndex = Number(img.dataset.fallbackIndex || "0");
  const nextIndex = currentIndex + 1;

  if (nextIndex >= fallbacks.length) return;

  img.dataset.fallbackIndex = String(nextIndex);
  img.src = fallbacks[nextIndex];
}

const OurStudent: React.FC = () => {
  // NOTE: background image removed for now as per your request
  // const heroBg = 'url("...")';
  const PROGRAM_BROCHURE_URL =
    "https://drive.google.com/file/d/1l5rloH-eS_x0pKcriMMPvX-Mg5DIixDU/view?usp=sharing";

  const studentVideos = useMemo<VideoItem[]>(
    () => [
      {
        title: "Student Video 1",
        youtubeId: "vAr1Tp_eYXQ",
      },
      {
        title: "Student Video 2",
        youtubeId: "-xd_v3G7RaI",
      },
      {
        title: "Student Video 3",
        youtubeId: "wZ776eKg3BU",
      },
      {
        title: "Student Video 4",
        youtubeId: "ewwGle3U7Hk",
      },
      {
        title: "Student Video 5",
        drivePreviewUrl: "https://drive.google.com/file/d/1IGGe0AGry2e_p51HfgG4weHMfaPr12uI/preview",
      },
    ],
    []
  );

  const mentoredStudents = useMemo<MentoredStudentCard[]>(
    () => [
      {
        name: "Akhil Jaiswal",
        subtitle: "IIT-JEE",
        driveImageId: "16cKNw-uwxq4zHJCdhqG-nyTjrcfj9AaZ",
        driveTextImageId: "1C09_c9CBmOCMJWPgxuQraDD1DDf247C3",
      },
      {
        name: "Pritish Abhinav ",
        subtitle: "NEET",
        driveImageId: "1iRNLiIzUHd7IjIX8Q2H0t730xP70INRw",
        driveTextImageId: "1ZoyShSjYZJzxpT6X4Eca1mzwhZ9C8Cjl",
      },
      {
        name: "Animesh Pati",
        subtitle: "NEET",
        driveImageId: "18-mV276R3igYCyMZrrXskCmS76zeb9d7",
        driveTextImageId: "1Z7qNpMHX7r_MoCDXzIT1XDYbbgiS8DCL",
      },
      {
        name: "Avnish Gujjar",
        subtitle: "NEET",
        driveImageId: "133qtoHtJbcLsrHihVGBLogdfMsJ-ip1I",
        driveTextImageId: "1vYZHRb6L4m8epLA7CwKFIFAXknVZv_Bj",
      },
      {
        name: "Ishan Neema",
        subtitle: "NEET",
        driveImageId: "10WOMatq8afQrew1O-13B5Lroj720-SQk",
        driveTextImageId: "1WNz5H_WFKZXrHbkuuJCxp4LdO-oHphRp",
      },
      {
        name: "Preeti Goyal",
        subtitle: "NEET",
        driveImageId: "18tBPSdvVAyZEoVUI7xYosjS0VUlanKQV",
        driveTextImageId: "",
      },
      {
        name: "Hardik",
        subtitle: "IIT-JEE",
        driveImageId: "11VXCQbRZLCnEVy9IFuIUlrs2qEWeeNFt",
        driveTextImageId: "1DSH68XCZoBAZ4IygnTr8HTsn4bb6GZj7",
      },
      {
        name: "Student",
        subtitle: "NEET",
        driveImageId: "1-CS4NbVZDfJxSc39l4j3i6_E9Fl2G-8I",
        driveTextImageId: "1tUZxGunZYqp5go4ZaeKNMpZThPLDmsEU",
      },
    ],
    []
  );

  return (
    <div className="our-student-page">
      {/* HERO */}
      <section className="os-hero" aria-label="S-CUBUS Wall of Fame">
        <div className="os-hero__overlay" />

        {/* ❌ background image removed for now */}
        {/* <div className="os-hero__bg" style={{ backgroundImage: heroBg }} /> */}

        <div className="os-container os-hero__content">
          <div className="os-pill">
            <span className="material-symbols-outlined os-pill__icon">military_tech</span>
            <span className="os-pill__text">Excellence in Education since 2010</span>
          </div>

          <h1 className="os-hero__title">S-CUBUS Wall of Fame</h1>
          <p className="os-hero__subtitle">
            Celebrating the relentless hard work, dedication, and phenomenal success of our students in JEE, NEET, and
            Olympiads.
          </p>
        </div>
      </section>

      {/* STATS BAR */}
      <section className="os-stats-wrap" aria-label="Statistics">
        <div className="os-container">
          <div className="os-stats os-stats--single">
            <div className="os-stat">
              <div className="os-stat__iconWrap">
                <span className="material-symbols-outlined os-stat__icon">groups</span>
              </div>
              {/* <div className="os-stat__value">1000+</div> */}
              {/* <div className="os-stat__label">SUCCESS STORIES</div> */}
              <div className="os-stat__value">Many Success Stories</div>
              {/* <div className="os-stat__label">SUCCESS STORIES</div> */}
            </div>
          </div>
        </div>
      </section>

      {/* ✅ Featured centered video */}
      <section className="os-featuredVideo" aria-label="Featured video">
        <div className="os-container">
          <div className="os-featuredVideo__frameWrap">
            <iframe
              className="os-featuredVideo__frame"
              src="https://www.youtube.com/embed/3c14NbxW4GQ"
              title="Featured student video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      {/* ✅ NEW: STUDENT VIDEOS ROW SECTION */}
      <section className="os-videoRow" aria-label="Student videos">
        <div className="os-container">
          <div className="os-videoRow__head">
            <div>
              <div className="os-kicker">STUDENT VIDEOS</div>
              <h2 className="os-h2">Watch Our Students</h2>
            </div>
          </div>

          <div className="os-videoRow__grid">
            {studentVideos.map((v, idx) => (
              <div key={v.title + idx} className="os-videoTile">
                <div className="os-videoTile__iframeWrap">
                  <iframe
                    className="os-ytFrame"
                    src={
                      v.drivePreviewUrl
                        ? v.drivePreviewUrl
                        : `https://www.youtube.com/embed/${v.youtubeId}`
                    }
                    title={v.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="os-videoTile__caption">{v.title}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ✅ RESTORED (Muted): Previously Mentored Students */}
      <section className="os-mentored" aria-label="Previously mentored students">
        <div className="os-container">
          <div className="os-mentored__title">
            <div className="os-kicker">SUCCESS STORIES</div>
            <h2 className="os-h2 os-h2--big">Previously Mentored Students</h2>
          </div>

          <div className="os-mentored__grid">
            {mentoredStudents.map((s, idx) => (
              <div key={s.name + idx} className="os-mentoredCard">
                <img
                  className="os-mentoredCard__img"
                  src={getDriveImageUrl(s.driveImageId)}
                  data-fallbacks={getDriveImageFallbacks(s.driveImageId).join("|")}
                  data-fallback-index="0"
                  onError={handleDriveImageError}
                  alt={s.name}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />

                {s.driveTextImageId ? (
                  <img
                    className="os-mentoredCard__text"
                    src={getDriveImageUrl(s.driveTextImageId)}
                    data-fallbacks={getDriveImageFallbacks(s.driveTextImageId).join("|")}
                    data-fallback-index="0"
                    onError={handleDriveImageError}
                    alt={`${s.name} note`}
                    loading="lazy"
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <div className="os-mentoredCard__text os-mentoredCard__text--empty" />
                )}

                <div className="os-mentoredCard__meta">
                  <div className="os-mentoredCard__name">{s.name}</div>
                  {s.subtitle ? <div className="os-mentoredCard__sub">{s.subtitle}</div> : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ✅ UPDATED SECTION: You Will Be the Next */}
      <section className="os-next" aria-label="You will be the next">
        <div className="os-container">
          <div className="os-next__title">
            <div className="os-kicker">SUCCESS STORIES</div>
            <h2 className="os-h2 os-h2--big os-next__line1">
              You Will Be <span className="os-next__word-next">Next</span>
            </h2>
            <p className="os-next__tagline">
              Your <span className="os-next__accent1">Success</span>{" "}
              <span className="os-next__accent2">Story Begins</span> Here.
            </p>
          </div>

          <div className="os-next__imageWrap">
            <img className="os-next__image" src="/mode/unknown.jpg" alt="You will be the next success story" loading="lazy" />
            <img className="os-next__image" src="/mode/unknown_2.jpg" alt="You will be the next success story" loading="lazy" />
          </div>
        </div>
      </section>

      {/* ALUMNI */}
      <section className="os-alumni" aria-label="Alumni institutes">
        <div className="os-container os-alumni__inner">
          <h3 className="os-alumni__title">OUR ALUMNI STUDY AT TOP INSTITUTES</h3>

          <div className="os-alumni__grid">
            <div className="os-alumni__pill">IIT Bombay</div>
            <div className="os-alumni__pill">AIIMS Delhi</div>
            <div className="os-alumni__pill">IIT Delhi</div>
            <div className="os-alumni__pill">NIT Trichy</div>
            <div className="os-alumni__pill">BITS Pilani</div>
            <div className="os-alumni__pill">CMC Vellore</div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="os-cta" aria-label="Call to action">
        <div className="os-cta__shape os-cta__shape--tr" />
        <div className="os-cta__shape os-cta__shape--bl" />

        <div className="os-container os-cta__inner">
          <h2 className="os-cta__title">Be the Next Success Story.</h2>
          <p className="os-cta__sub">
            Join the league of toppers. Experience our result-oriented methodology with a free demo class today.
          </p>

          <div className="os-cta__btns">
            <a
              className="os-btn os-btn--white"
              href="https://forms.gle/xdExtHf2Yss4ZaHq9"
              target="_blank"
              rel="noopener noreferrer"
            >
              Register for Career Guidance
            </a>
            <a
              className="os-btn os-btn--outline"
              href={PROGRAM_BROCHURE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Brochure
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurStudent;
